/* global _satellite */
'use strict';

var Swiper = require('./thirdParty/swiper');

var MIN_SLIDE_COUNT;

/**
 * Init swiper carousel
 *
 * @param {jQuery} el - jQuery element
 * @param {boolean} allowSwipe - indicates whether swiping should be enabled
 * @param {boolean} isCDP - indicates CDP page
 * @return {Object} - swiper object
 */
function initSwiper(el, allowSwipe, isCDP) {
    var mySwiper = new Swiper(el, {
        a11y: true,
        autoHeight: false,
        slidesPerView: 1.8,
        freeMode: true,
        spaceBetween: 20,
        watchSlidesVisibility: true,
        allowTouchMove: allowSwipe,
        centerInsufficientSlides: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
                slidesPerGroup: 2,
                spaceBetween: isCDP ? 22 : 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        },
        on: {
            slideNextTransitionEnd: function () {
                var $container = $(this.el).closest('.visual-links-component');
                $container.find('.vql-tile.swiper-slide.swiper-slide-visible a, .vql-tile.swiper-slide.swiper-slide-visible img, .vql-tile.swiper-slide.swiper-slide-visible p, .vql-tile.swiper-slide:not(.swiper-slide-visible) .img-title').attr('tabindex', 0);
                $container.find('.vql-tile.swiper-slide:not(.swiper-slide-visible) a, .vql-tile.swiper-slide:not(.swiper-slide-visible) img, .vql-tile.swiper-slide:not(.swiper-slide-visible) p, .vql-tile.swiper-slide:not(.swiper-slide-visible) .img-title').attr('tabindex', -1);
                $container.find('.swiper-button.swiper-button-disabled').attr({ tabindex: -1, 'aria-hidden': true });
                $container.find('.swiper-button:not(.swiper-button-disabled)').attr({ tabindex: 0, 'aria-hidden': false });
                $container.find('.vql-tile.swiper-slide.swiper-slide-visible').last().find('.img-fluid')[0].focus();
            },
            slidePrevTransitionEnd: function () {
                var $container = $(this.el).closest('.visual-links-component');
                $container.find('.vql-tile.swiper-slide.swiper-slide-visible a, .vql-tile.swiper-slide.swiper-slide-visible img, .vql-tile.swiper-slide.swiper-slide-visible p, .vql-tile.swiper-slide:not(.swiper-slide-visible) .img-title').attr('tabindex', 0);
                $container.find('.vql-tile.swiper-slide:not(.swiper-slide-visible) a, .vql-tile.swiper-slide:not(.swiper-slide-visible) img, .vql-tile.swiper-slide:not(.swiper-slide-visible) p, .vql-tile.swiper-slide:not(.swiper-slide-visible) .img-title').attr('tabindex', -1);
                $container.find('.swiper-button.swiper-button-disabled').attr({ tabindex: -1, 'aria-hidden': true });
                $container.find('.swiper-button:not(.swiper-button-disabled)').attr({ tabindex: 0, 'aria-hidden': false });
                $container.find('.vql-tile.swiper-slide.swiper-slide-visible').first().find('.img-fluid')[0].focus();
            },
            init: function () {
                var $container = $(this.el).closest('.visual-links-component');
                $container.find('.vql-tile.swiper-slide:not(.swiper-slide-visible) a, .vql-tile.swiper-slide:not(.swiper-slide-visible) img, .vql-tile.swiper-slide:not(.swiper-slide-visible) p, .vql-tile.swiper-slide:not(.swiper-slide-visible) .img-title').attr('tabindex', -1);
                setTimeout(function () {
                    $container.find('.swiper-button.swiper-button-disabled').attr({ tabindex: -1, 'aria-hidden': true });
                    $container.find('.swiper-button:not(.swiper-button-disabled)').attr({ tabindex: 0, 'aria-hidden': false });
                }, 200);
            }
        }
    });

    return mySwiper;
}

/**
 * Init visual links carousel
 */
function initCarousel() {
    $('.visual-links-component').each(function () {
        var isCDP = $('#cdp-page-indicator').length > 0;
        if (!($(this).parent().hasClass('hide'))) {
            var $this = $(this);
            var $swiperWrapperEl = $(this).find('.swiper-parent');
            let slideCountQuery = window.matchMedia('(max-width: 767px)');
            var allowSwipe = true;
            if (slideCountQuery.matches) {
                MIN_SLIDE_COUNT = 2;
            } else {
                MIN_SLIDE_COUNT = 5;
            }
            var slotContentLength = $swiperWrapperEl.data('counter');
            if (slotContentLength < MIN_SLIDE_COUNT) {
                allowSwipe = false;
            }
            $swiperWrapperEl.addClass('swiper-wrapper');
            $this.find('.swiper-slide-init').addClass('swiper-slide');
            $swiperWrapperEl.removeClass('row');
            $this.find('.swiper-slide-init').removeClass('col');
            initSwiper($this, allowSwipe, isCDP);
            $this.find('.quick-links-wrapper').removeClass('d-none');

            // Setting top value for carousel arrow to center it vertically based on img height
            var imgHeight = $(this).find('.image-wrapper .img-fluid').height();
            var parentOffset = $(this).find('.swiper-parent')[0].offsetTop;
            if ($(this).find('.swiper-button-prev').length > 0 && $(this).find('.swiper-button-next').length > 0) { // If the buttons exist
                $(this).find('.swiper-button-prev').css({ top: (imgHeight / 2) + parentOffset });
                $(this).find('.swiper-button-next').css({ top: (imgHeight / 2) + parentOffset });
            }
        }
    });
}

/**
 * Track event on enhance anchor links
 * @param {string} icid - string
 */
function trackAnchorEvent(icid) {
    if (typeof _satellite !== 'undefined') {
        _satellite.track('anchor-link-click', {
            component: {
                id: icid,
                innerText: ''
            }
        });
    }
}

// Click on anchors with '#' at the beginning should not reload the page, but directly scroll to the referred component
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        if (!$(this).hasClass('hybrid-tab-link')) {
            e.preventDefault();
            var selector;
            var elementHead;
            var icid = '';
            var headerHeight = $('.header .navigation')[0].offsetHeight + 1;
            // If it is Page designer CTA component
            if ($(this).closest('.storepage').length) {
                if (this.getAttribute('href').indexOf('?') !== -1) {
                    elementHead = document.querySelector(this.getAttribute('href').split('?')[0]);
                } else {
                    elementHead = document.querySelector(this.getAttribute('href'));
                }
            } else { // If it is a BM component
                selector = 'a[name="' + this.getAttribute('href').split('#')[1] + '"]';
                if (document.querySelector(selector).closest('.anchor-element')) {
                    elementHead = document.querySelector(selector).closest('.anchor-element');
                } else if (document.querySelector(selector).closest('h2')) {
                    elementHead = document.querySelector(selector).closest('h2');
                } else if (document.querySelector(selector).closest('.container')) {
                    elementHead = document.querySelector(selector).closest('.container');
                }
            }

            // Analytics
            var queryParam = this.getAttribute('href').split('?')[1];
            if (queryParam) {
                if (queryParam.split('=')[0] === 'icid') {
                    icid = queryParam.split('=')[1];
                }
            }
            trackAnchorEvent(icid);
            $('html, body').animate({
                scrollTop: $(elementHead).offset().top - headerHeight
            },
                {
                    duration: 1500,
                    step: function (now, fx) {
                        var newOffset = $(elementHead).offset().top - headerHeight;
                        if (fx.end !== newOffset) {
                            // eslint-disable-next-line no-param-reassign
                            fx.end = newOffset;
                        }
                    }
                });
        }
    });
});

/**
 * click event on enhance anchor links
 * @param {jQuery} ele - anchor element
 * @param {string} icid - icid
 */
function anchorEvent(ele, icid) {
    $(ele).on('click', function (e) {
        e.preventDefault();
        trackAnchorEvent(icid);
        window.location.href = $(this).attr('href');
    });
}

// Click on anchors with url when we used along with the enhanced anchorlinks
var links = $('.visual-links-component a[href*="http"]');
for (var i = 0; i < links.length; i++) {
    var params = $(links[i]).attr('href').split('?')[1];
    var icid = '';
    if (params) {
        if (params.split('=')[0] === 'icid') {
            icid = params.split('=')[1];
            anchorEvent(links[i], icid);
        }
    }
}

/**
 * Initialize listeners for resize
 */
function init() {
    initCarousel();
}

$(window).on('resize', function () {
    init();
});

if (('onhashchange' in window) && !($.browser.msie)) {
    var hash = location.hash.split('?')[0];
    if (hash) {
        var headerHeight;
        setTimeout(function () {
            if ($('.search-mobile').is(':visible')) {
                headerHeight = $('.header .navigation')[0].offsetHeight + $('.search-mobile')[0].offsetHeight + 1;
            } else {
                headerHeight = $('.header .navigation')[0].offsetHeight + 1;
            }
            $('html, body').animate({
                scrollTop: $(hash).offset().top - headerHeight
            }, 500);
        }, 100);
    }
}

module.exports = {
    init: init,
    initCarousel: initCarousel
};
